import React, {useEffect, useState} from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Layout from "@/Layout";
import Home from "@/view/Home";
import LandingV2 from "@/view/LandingV2";
import SendCord from "@/view/SendCord";
import Ecosystem from "@/view/Ecosystem";
import Swap from '@/view/Swap'
import Bridge from '@/view/Bridge'
import Vaisa from '@/view/Vaisa'
import Blog from "@/view/Blog";
import BlogDetail from "@/view/BlogDetail";
import Solutions from "@/view/Solutions";
import NonCustodial from "@/view/NonCustodial";
import Custodial from "@/view/Custodial";
import Podcast from "@/view/Podcast";
import DigitalAssets from "@/view/DigitalAssets";
import PrivateCredit from "@/view/PrivateCredit";
import TokenizedRWA from "@/view/TokenizedRWA";
import ERC from "@/view/ERC";
import Seo from '@/seo/Seo'
import CookiePolicy from '@/view/Agreements/CookiePolicy.js'
import PrivacyPolicy from '@/view/Agreements/PrivacyPolicy.js'
import TermsOfService from '@/view/Agreements/TermsOfService.js'

const AppRoutes = () => {

    const [loadState, setLoad] = useState(false) // 是否加载中
    const [isLoadingVisible, setIsLoadingVisible] = useState(true); // 控制平缓隐藏

    useEffect(() => {
        let time = null
        if (loadState) {
            document.body.style.overflow = "hidden";

            setLoad(false)
            document.body.style.overflow = "";
            setIsLoadingVisible(false);

            // time = setTimeout(() => {
            //     setLoad(false)
            //
            //     setTimeout(() => {
            //         setIsLoadingVisible(false);
            //         // 恢复滚动
            //         document.body.style.overflow = "";
            //     }, 1); // 延迟隐藏Loading
            // }, 0)
        }

        return () => {
            time && clearTimeout(time)
            document.body.style.overflow = "";
        }
    }, [loadState])


    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Seo/>
            {
                !loadState && <>
                    <Routes>
                        {/* v3 pages render their own nav/footer, so they live outside Layout */}
                        <Route path="/" element={<LandingV2/>}/>
                        <Route path='/podcast' element={<Podcast/>}></Route>
                        <Route element={<Layout/>}>
                            <Route path="/home" element={<Home/>}/>
                            <Route path="/ecosystem" element={<Ecosystem/>}></Route>
                            <Route path='/swap' element={<Swap/>}></Route>
                            <Route path='/blog' element={<Blog/>}></Route>
                            <Route path='/blogDetail' element={<BlogDetail/>}></Route>
                            <Route path='/solutions' element={<Solutions/>}></Route>
                            <Route path='/nonCustodial' element={<NonCustodial/>}></Route>
                            <Route path='/custodial' element={<Custodial />}></Route>
                            <Route path='/cookie-policy' element={<CookiePolicy/>}></Route>
                            <Route path='/privacy-policy' element={<PrivacyPolicy/>}></Route>
                            <Route path='/terms-of-service' element={<TermsOfService/>}></Route>
                            <Route path='/digitalAssets' element={<DigitalAssets/>}></Route>
                            <Route path='/privateCredit' element={<PrivateCredit/>}></Route>
                            <Route path='/tokenizedRWA' element={<TokenizedRWA/>}></Route>
                            <Route path='/erc' element={<ERC/>}></Route>

                        </Route>
                        <Route path="/send" element={<SendCord/>}></Route>
                        <Route path='/bridge' element={<Bridge/>}></Route>
                        <Route path='/vaisa' element={<Vaisa/>}></Route>

                    </Routes>
                </>
            }
        </Router>
    );
};

export default AppRoutes;
